document.addEventListener('DOMContentLoaded', () => {
	let lastScrollTop = 0;
	const offset = 100;
	const buttons = document.querySelectorAll('.footer-jump-button');
    console.log(buttons);
        

	window.addEventListener('scroll', () => {
		let currentScroll = document.documentElement.scrollTop;

		if (currentScroll > lastScrollTop && currentScroll > offset) { // Scrolling down.
			buttons.forEach((button) => {
				button.classList.add('hidden');
			});
		} else { // Scrolling up.
			buttons.forEach((button) => {
				button.classList.remove('hidden');
			});
		}

		lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For mobile or negative scrolling.
	});
});